import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {BaasicDropdown} from 'core/components';
import {QueryUtility} from "core/utils";
import {defaultTemplate} from "core/hoc";
import {BaasicDropdownStore} from 'core/stores';

class QueryDropdownTemplate extends React.Component{
    constructor(props) {
        super();
        this.queryUtility = props.queryUtility;
        this.store = props.store;
        this.propertyName = props.propertyName;
        this.label = props.label;
        this.placeholder = props.placeholder;
        this.t = props.t;
        this.onChange = props.onChange;
        this.onClearProp = props.onClear;
        this.clearable = props.clearable != null ? props.clearable : true;
        this.isFetch = props.isFetch;

        let val = this.queryUtility.filter[this.propertyName];
        if (!(val && this.store.value && typeof this.store.value === 'object' && this.store.value[this.store.options.dataItemKey] === val)){
           this.store.setValue(val);
        }

        this.store.onChange = (event) => {
            let value = event;
            this.store.setValue(value);
            if (value && typeof value === 'object') {
                this.queryUtility.filter.set(this.propertyName, value[this.store.options.dataItemKey]);
            } else {
                this.queryUtility.filter.set(this.propertyName, null);
            }
            if(this.onChange){
                this.onChange(event);
            }
            if (this.store) {
                this.store.onFilter("");
            }
        };
        this.onClear = () => {
            this.store.setValue(null);
            this.queryUtility.filter.set(this.propertyName, null);
            if(this.onClearProp){
                this.onClearProp();
            }
            if(this.isFetch)
                this.queryUtility.fetch();
            if (this.store) {
                this.store.onFilter("");
            }
        }
    }

    render(){
        return (
            <Fragment>
                <div className='form__group__label'>{this.label}</div>
                <div
                    className="u-position--rel"
                    // className={this.store.value && this.clearable ? 'is-selected' : ''}
                >
                    <div className="k-textbox-container">
                        <BaasicDropdown store={this.store} placeholder={this.placeholder} itemRender={this.props.itemRender} valueRender={this.props.valueRender} />
                        {this.store.value && this.clearable &&
                            <button className='k-clear-button' onClick={() => this.onClear()}>
                                <span className="u-icon u-icon--xsml u-icon--close--primary"></span>
                            </button>
                        }
                    </div>
                </div>
            </Fragment>
        )
    }

}
QueryDropdownTemplate.propTypes = {
    queryUtility: PropTypes.instanceOf(QueryUtility),
    store: PropTypes.instanceOf(BaasicDropdownStore),
    propertyName: PropTypes.string,
    label: PropTypes.any,
    placeholder: PropTypes.any,
    t: PropTypes.any,
    onChange: PropTypes.any,
    onClear: PropTypes.func,
    clearable: PropTypes.any,
    isFetch: PropTypes.bool,
    itemRender: PropTypes.func,
    valueRender: PropTypes.func
};
export default defaultTemplate(QueryDropdownTemplate);
